import { Timestamp } from "firebase/firestore";
import { DateTime } from "luxon";

export const getDateAfterYear = (): Timestamp => {
  const currentDate = new Date();
  const nextYearDate = new Date(currentDate);
  nextYearDate.setFullYear(currentDate.getFullYear() + 1);
  return Timestamp.fromDate(nextYearDate);
};

export const getCurrentDate = (): Timestamp => Timestamp.fromDate(new Date());

export const displayDate = (date: Timestamp | number): string => {
  const jsDate = date instanceof Timestamp ? date.toDate() : typeof date === "number" ? new Date(date) : new Date(date);

  return DateTime.fromJSDate(jsDate).toFormat("dd LLL yyyy, HH:mm");
};

// Helper function to format timestamp
export const formatTimestamp = (timestamp: Timestamp) => {
  if (!timestamp) return "N/A";

  const date = new Date(timestamp.seconds * 1000);

  return date.toLocaleString("en-US", {
    dateStyle: "short",
    timeStyle: "short",
  });
};

export const getDuration = (start: Timestamp, end?: Timestamp): string => {
  if (!end) return "__";
  const diff = end.seconds - start.seconds;
  const hours = Math.floor(diff / 3600);
  const minutes = Math.floor((diff % 3600) / 60);
  const seconds = diff % 60;

  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;
  return `${seconds}s`;
};
